import script from "./DashBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoard.vue?vue&type=script&setup=true&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=5f2dda10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2dda10"]])

export default __exports__